import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscribed-successfully',
  templateUrl: './subscribed-successfully.component.html',
  styleUrls: ['./subscribed-successfully.component.scss']
})
export class SubscribedSuccessfullyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
